module.exports = __webpack_public_path__ + "static/media/nav-patients-active.a0dc6946.svg";